import { render } from "./CustomImage.vue?vue&type=template&id=11d58f07"
import script from "./CustomImage.vue?vue&type=script&lang=js"
export * from "./CustomImage.vue?vue&type=script&lang=js"

import "./CustomImage.vue?vue&type=style&index=0&id=11d58f07&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__